import { render } from "./TdHelp.vue?vue&type=template&id=550edd4a&scoped=true"
import script from "./TdHelp.vue?vue&type=script&lang=js"
export * from "./TdHelp.vue?vue&type=script&lang=js"

import "./TdHelp.vue?vue&type=style&index=0&id=550edd4a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-550edd4a"]])

export default __exports__